import { Amplify } from "aws-amplify";
import {
  Authenticator,
  ThemeProvider,
  View,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavigationBar from "./Navigation/Navbar";
import amplifyConfig from "./amplifyconfig.json";
import { loginScreen } from "./styles/app";
import { useTheme } from "@aws-amplify/ui-react";
import { Text as AText, Heading as AHeading } from "@aws-amplify/ui-react";
import Icon from "./Images/PostOfficeLogo";
import { ApolloProvider } from "@apollo/client";
import { graphQlClient } from "./graphql/client";
import "./styles/app.css";
import { lightTheme, darkTheme } from "./theme";
import { Mode, useColorMode } from "./colorModeSwitcher";

Amplify.configure(amplifyConfig);

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Icon />
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();

    return (
      <View
        textAlign="center"
        padding={tokens.space.large}
        style={{ color: tokens.colors.font.secondary.value }}
      >
        <AText>&copy; All Rights Reserved</AText>
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <AHeading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Sign in
        </AHeading>
      );
    },
    Footer() {
      return <View textAlign="center"></View>;
    },
  },
};

const formFields = {
  signIn: {
    username: {
      label: "Email",
      placeholder: "Enter your email",
      labelHidden: false,
    },
    password: {
      label: "Password",
      placeholder: "Enter your Password",
      labelHidden: false,
    },
  },
  forceNewPassword: {
    password: {
      placeholder: "Enter your Password",
    },
  },
  setupTOTP: {
    QR: {
      totpIssuer: "TAM Backoffice",
    },
    confirmation_code: {
      placeholder: "Enter your Confirmation Code",
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      placeholder: "Enter your Confirmation Code",
      isRequired: false,
    },
  },
};

const App = () => {
  const { route, user } = useAuthenticator((context) => [context.route]);

  let userEmail = user?.attributes?.email;
  let name = userEmail && userEmail.replace(/@.*$/, "");
  localStorage.setItem("USER_NAME", name);

  const { mode, setMode, isDark } = useColorMode("system");
  const theme = isDark ? darkTheme : lightTheme;

  if (window.self === window.top) {
    return (
      <ThemeProvider theme={theme} colorMode={mode}>
        <header style={loginScreen.themeSelectorView}>
          <span style={loginScreen.themeText}>Theme</span>
          <select
            value={mode}
            className="theme-select"
            aria-label="Theme mode"
            onChange={(e) => setMode(e.target.value as Mode)}
            style={{
              borderRadius: 6,
              padding: "0.25rem 0.5rem",
              border: "1px solid #ccc",
            }}
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
            <option value="system">System</option>
          </select>
        </header>
        <div
          className="auth-surface"
          style={!isDark ? loginScreen.lightAppView : loginScreen.darkAppView}
        >
          <Authenticator
            hideSignUp={true}
            className="auth-root"
            components={components}
            formFields={formFields}
          >
            {({ signOut }) =>
              route !== "authenticated" ? (
                /* --- Login View --- */
                <div style={loginScreen.loginContainer}>
                  <div style={loginScreen.innerAppView}></div>
                </div>
              ) : (
                /* --- Full screen - App View --- */
                <ApolloProvider client={graphQlClient(signOut)}>
                  <div style={loginScreen.fullAppView}>
                    <NavigationBar signOut={signOut} />
                  </div>
                </ApolloProvider>
              )
            }
          </Authenticator>
        </div>
      </ThemeProvider>
    );
  } else {
    return <div>Invalid request.</div>;
  }
};

export default App;
